"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
require("./bootstrap");
require("../css/app.css");
var react_1 = __importStar(require("react"));
var client_1 = require("react-dom/client");
var inertia_react_1 = require("@inertiajs/inertia-react");
var progress_1 = require("@inertiajs/progress");
var Loading_1 = __importDefault(require("./Components/common/Loading"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var appErrorBoundary_1 = __importDefault(require("./appErrorBoundary"));
var PermissionContext_1 = require("@/Components/common/PermissionContext");
require("../js/Components/i18n");
require("./Types/FontAwesomeLoad");
var QMSMediaLibraryHandler_1 = __importDefault(require("./Components/MediaLibrary/QMSMediaLibraryHandler"));
(0, q_play_components_1.setup)();
q_play_core_1.logManager
    .registerLogChannel(new q_play_core_1.MongoLogChannel())
    .registerLogChannel(new q_play_core_1.ConsoleLogChannel())
    .configure({ level: q_play_core_1.LogLevels.WARN });
var appName = ((_a = window.document.getElementsByTagName("title")[0]) === null || _a === void 0 ? void 0 : _a.innerText) || "Laravel";
var app = document.getElementById("app");
var root = (0, client_1.createRoot)(app);
(0, inertia_react_1.createInertiaApp)({
    title: function (title) { return "".concat(title, " - ").concat(appName); },
    resolve: function (name) { return require("./Pages/".concat(name, ".tsx")); },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup: function (_a) {
        var el = _a.el, App = _a.App, props = _a.props;
        return (root.render(react_1.default.createElement(PermissionContext_1.PermissionsProvider, null,
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loading_1.default, null) },
                react_1.default.createElement(appErrorBoundary_1.default, null,
                    react_1.default.createElement(App, __assign({}, props)),
                    react_1.default.createElement(QMSMediaLibraryHandler_1.default, null))))));
    },
});
progress_1.InertiaProgress.init({ color: "#4B5563" });
